import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import AnticipationCard from './AnticipationCard';
import AvailableCard from './AvailableCard';
import FutureCard from './FutureCard';
import styles from './styles';
import TotalCard from './TotalCard';

function CardList() {
  const classes = styles();

  const [hasValueToAnticipate, setHasValueToAnticipate] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [anticipateModal, setAnticipateModal] = useState(false);
  const [loadingTransferAvailable, setLoadingTransferAvailable] = useState(true);

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const cannotAntecipate = eduzzAccountsService.verifyUserHasBetaModule('cannot-antecipate');

  const [loadTransferAvailable] = useCallbackObservable(() => {
    setLoadingTransferAvailable(true);
    return financialStatementService.getAvailable().pipe(
      tap(({ data }) => {
        financialStatementService.setCurrentBalance(user?.crossborder ? data.total_origin : data.total);
        setLoadingTransferAvailable(false);
      }),
      catchError((error) => {
        toast.error(error);
        setLoadingTransferAvailable(false);
        return of(true);
      })
    );
  }, []);

  const toggleTransferModal = () => setTransferModal((prevState) => !prevState);
  const toggleAnticipationModal = () => setAnticipateModal((prevState) => !prevState);

  const showAntecipate = !cannotAntecipate;
  const mdType = showAntecipate ? 3 : 4;

  return (
    <Grid id='card-list' className={classes.root} container spacing={2}>
      <Grid item xs={12} sm={6} md={mdType}>
        <TotalCard />
      </Grid>
      <Grid item xs={12} sm={6} md={mdType}>
        <AvailableCard
          isLoading={loadingTransferAvailable}
          modalTransferIsOpen={transferModal}
          hasValueToAnticipate={hasValueToAnticipate}
          fetchData={loadTransferAvailable}
          handleToggleTransferModal={toggleTransferModal}
          handleToggleAnticipateModal={toggleAnticipationModal}
        />
      </Grid>
      {showAntecipate && (
        <Grid item xs={12} sm={6} md={3}>
          <AnticipationCard
            modalAnticipateIsOpen={anticipateModal}
            updateTransferAvailable={loadTransferAvailable}
            handleToggleTransferModal={toggleTransferModal}
            handleToggleAnticipateModal={toggleAnticipationModal}
            handleSetHasValueToAnticipate={setHasValueToAnticipate}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={mdType}>
        <FutureCard />
      </Grid>
    </Grid>
  );
}

export default CardList;
